import React from 'react';
import AdminLayout from '../../../Components/CommonComponents/Layout/adminLayout';
import SponsorsContainer from '../../../Containers/AdminContainer/Sponsors';

const SponsorScreen = () => {
  return <SponsorsContainer />;
};

export default SponsorScreen;
